import React from 'react';
import {Button, Form, InputGroup} from "react-bootstrap";
import Icon from "@mdi/react";
import {mdiCloseCircleOutline} from "@mdi/js";


export default class Search extends React.Component {
    constructor(props) {
        super(props);
    }

    handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            this.props.onSubmit(event);
        }
    }

  render() {
    // Inline-Stile
    const clearIconStyle = {
      position: "absolute",
      right: "45px", // Abstand vom rechten Rand oder Button
      top: "50%",
      transform: "translateY(-50%)",
      cursor: "pointer",
      color: "#6c757d", // Farbe des Icons
      zIndex: 2, // Über dem Text positioniert
    };

    const clearIconHoverStyle = {
      ...clearIconStyle, // Basis-Styles übernehmen
      color: "#dc3545", // Hover-Farbe
    };

    return (
      <InputGroup className={`mb-3 position-relative ${this.props.className}`}>
        <Form.Control
          disabled={this.props.disabled}
          placeholder={this.props.placeholder}
          aria-label="search"
          value={this.props.value}
          onChange={this.props.onChange}
          onKeyDown={this.handleKeyDown}
          type={"search"}
        />
        <Button
          type={"submit"}
          disabled={this.props.disabled}
          onClick={this.props.onSubmit}
          variant="outline-secondary"
          id="button-addon2"
        >
          {this.props.children}
        </Button>
      </InputGroup>
    );
  }
}
